import React, { useState, useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import styled, { keyframes } from "styled-components";

import moment from "moment";
import lodash from 'lodash';

import FetchModule from "../../../../Share/Network/FetchModule";

import CustomInput from "../../../../../MemberRegistration/Component/CustomInput";
import CalenderInput from "../../../../../MemberRegistration/Component/CalendarInput";
import DiscountAmountInput from "../../../../../Component/MemberComponent/DiscountAmountInput";
import PaymentOptionCustomInput from "../../../../../MemberRegistration/Component/PaymentOptionCustomInput";

import OptionSelectBox from "../../../../../MemberRegistration/Model/OptionSelectBox";
import PaymentOptionSettingSelectBox from "../../../../../MemberRegistration/Model/PaymentOptionSettingSelectBox";
import AddPaymentOptionModal from "../../../../../MemberRegistration/Model/AddPaymentOptionModal";
import LinkoPayPaymentModal from "../../../../../MemberRegistration/Model/LinkoPayPaymentModal";
import OnSitePaymentModal from "../../../../../MemberRegistration/Model/OnSitePaymentModal";
import TotalModalWrapper from "../../../../Share/Normal/TotalModalWrapper";

import { ReactComponent as TrashIcon } from '../../../../../image/Trash.svg';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function MembershipPaymentModal(props) {
  const {
    memberId,
    memberName,
    totalPoint,
    recentlyMembership,
    selectedEditMembership,
    onClickExit
  } = props;

  const history = useHistory();
  const { t, isEng } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  // status //
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [isUseLinkoPay, setIsUseLinkoPay] = useState(false);
  const [isViewPaymentModal, setIsViewPaymentModal] = useState(false);

  const [isInProgress, setIsInProgress] = useState(false);
  const [isLinkPayPaid, setIsLinkPayPaid] = useState(false);

  const skipMembershipAutoFillRef = useRef(false);
  // status //

  // value //
  const [prevSalesColor, setPrevSalesColor] = useState(theme.text);

  const [memberships, setMemberships] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categorizedMemberships, setCategorizedMemberships] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({ id: 0, name: t('memberDetail.select') });
  const [selectedMembership, setSelectedMembership] = useState({ id: 0, name: t('memberDetail.select') });
  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);
  const isLinkoPayActive = selectedPaymentOptions.some(opt => opt.name === '링코페이');

  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY.MM.DD'));
  const [approvalDate, setApprovalDate] = useState(moment().format('YYYY.MM.DD'));
  const [totalMax, setTotalMax] = useState(-1);
  const [discount, setDiscount] = useState('0');
  const [notReceived, setNotReceived] = useState('0');
  const [usedPoint, setUsedPoint] = useState(0);

  const [originalApprovalDate, setOriginalApprovalDate] = useState('');
  const [originalCardPrice, setOriginalCardPrice] = useState('');
  const [originalSelectedPaymentOptions, setOriginalSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);

  // 링크페이 사용여부 확인하기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getIndividualData('store/check/linkpay', 'GET');

        if (responseData.status === 200) setIsUseLinkoPay(responseData.data[0]);
      }
    )();
  }, [])

  // 카테고리 및 회원권 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');

        if (responseData.status === 200) {
          setMemberships(responseData.data.memberShips);
          setCategories(responseData.data.categories);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history])

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // 회원권 생성 또는 수정여부 결정 //
  useEffect(() => {
    setIsEdit(selectedEditMembership !== undefined);

    if (selectedEditMembership === undefined) {
      setIsEdit(false);

      setSelectedCategory({ id: 0, name: t('memberDetail.select') });
      setSelectedMembership({ id: 0, name: t('memberDetail.select') });
      setSelectedPaymentOptions([{ id: 0, name: '현금', price: 0 }]);

      setStartDate(moment().format('YYYY.MM.DD'));
      setEndDate(moment().format('YYYY.MM.DD'));
      setApprovalDate(moment().format('YYYY.MM.DD'));
      setTotalMax(-1);
      setDiscount('0');
      setNotReceived('0');
      setUsedPoint(0);
    }
    else {
      setIsEdit(true);
      skipMembershipAutoFillRef.current = true;

      const willSelectCategory = categories.find(c => c.id === selectedEditMembership.categoryId) || { id: 0, name: t('memberDetail.select') };
      const willSelectMembership = memberships.find(m => m.id === selectedEditMembership.memberShipId) || { id: 0, name: t('memberDetail.select') };

      setSelectedCategory(willSelectCategory);

      setTimeout(() => {
        setSelectedMembership(willSelectMembership)
        setStartDate(moment(selectedEditMembership.startDate).format('YYYY.MM.DD'));
        setEndDate(moment(selectedEditMembership.endDate).format('YYYY.MM.DD'));
        setApprovalDate(moment(selectedEditMembership.approvalDate).format('YYYY.MM.DD'));
      }, 150);

      setTimeout(() => {
        skipMembershipAutoFillRef.current = false;
      }, 300);

      const merchantUidPart = selectedEditMembership.merchantUid?.split('-')[2];
      const isLinkoPayMerchant = merchantUidPart === '1' || merchantUidPart === '2';
      const isUnpaidLinkoPayCase = isLinkoPayMerchant && selectedEditMembership.isExpectedMemberShip !== false;
      const isCompletedLinkoPayCase = isLinkoPayMerchant && !isUnpaidLinkoPayCase;

      if (selectedEditMembership.selectedPaymentOptions !== undefined
        && selectedEditMembership.selectedPaymentOptions.length > 0) {
        const rawOptions = selectedEditMembership.selectedPaymentOptions;
        const finalOptions = (isUnpaidLinkoPayCase || isCompletedLinkoPayCase)
          ? rawOptions.map(opt => opt.name === '포인트' ? opt : { ...opt, name: '링코페이' })
          : rawOptions;
        setSelectedPaymentOptions(finalOptions);

        let usedPoint = 0;

        for (let i = 0; i < rawOptions.length; i++) {
          if (rawOptions[i].paymentOptionId === 0 && rawOptions[i].name === '포인트') {
            usedPoint += rawOptions[i].price;
          }
        }

        setUsedPoint(usedPoint);
      }
      else {
        let newSelectedPaymentOptions = [];

        if (isUnpaidLinkoPayCase) {
          newSelectedPaymentOptions.push({ id: 0, name: '링코페이', price: selectedEditMembership.cardPrice || 0 });
        }
        else {
          if (selectedEditMembership.cashPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '현금', price: selectedEditMembership.cashPrice });
          if (selectedEditMembership.cardPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: isLinkoPayMerchant ? '링코페이' : '카드', price: selectedEditMembership.cardPrice });
          if (selectedEditMembership.point !== 0) {
            newSelectedPaymentOptions.push({ id: 0, name: '포인트', price: selectedEditMembership.point });
            setUsedPoint(selectedEditMembership.point);
          }
        }

        setSelectedPaymentOptions(newSelectedPaymentOptions);
      }

      setDiscount(selectedEditMembership.discountPrice.toLocaleString('ko-KR'));
      setNotReceived(selectedEditMembership.notReceivedPrice.toString());

      setTimeout(() => {
        setTotalMax(selectedEditMembership.totalMax);
      }, 500)
    }
  }, [categories, memberships, selectedEditMembership])

  // 카테고리에 따라 회원권 정렬하기 //
  useEffect(() => {
    if (selectedCategory === undefined || selectedCategory.id === 0) {
      setCategorizedMemberships([]);
      setSelectedMembership({ id: 0, name: t('memberDetail.select') });
      return;
    }

    const newCategorizedMemberships = [];

    for (let i = 0; i < memberships.length; i++) {
      if (selectedCategory.id === memberships[i].categoryId) {
        newCategorizedMemberships.push(memberships[i]);
      }
    }

    setSelectedMembership({ id: 0, name: t('memberDetail.select') });
    setCategorizedMemberships(newCategorizedMemberships);
  }, [selectedCategory, memberships])

  // 회원권 셀렉 변경 시 종료일 자동 재계산 (초기 모달 오픈 / 카테고리 변경 / 이전 회원권 복사 등에서는 발화 안함) //
  function onChangeSelectedMembership(newMembership) {
    setSelectedMembership(newMembership);

    if (newMembership === undefined || newMembership.id === 0) return;
    if (startDate === '') return;

    const validity = newMembership.validity;
    const division = newMembership.validityUnit;

    setEndDate(moment(startDate, 'YYYY.MM.DD').add(validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
  }

  // 시작일 변경 시 종료일 자동 재계산 //
  function onChangeStartDate(newStartDate) {
    setStartDate(newStartDate);

    if (newStartDate === '') return;
    if (selectedMembership.id === 0) return;

    const validity = selectedMembership.validity;
    const division = selectedMembership.validityUnit;

    setEndDate(moment(newStartDate, 'YYYY.MM.DD').add(validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
  }

  // 미수금 산정하기 //
  useEffect(() => {
    if (selectedMembership.id === 0) {
      setNotReceived(0);
      return;
    }

    let totalPrice = 0;

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price != null && selectedPaymentOptions[i].price !== '') totalPrice += parseInt(selectedPaymentOptions[i].price.toString().replaceAll(',', '') ?? 0);
    }

    if (discount !== '') totalPrice += parseInt(discount.replaceAll(',', ''));

    setNotReceived(Math.max(selectedMembership.price - totalPrice, 0));
  }, [selectedMembership, selectedPaymentOptions, discount]);

  // 회원권 총 횟수 세팅 //
  useEffect(() => {
    if (selectedMembership.id === 0) setTotalMax(-1);
    else setTotalMax(selectedMembership.totalMax);
  }, [selectedMembership])

  // 회원권 선택하면 첫 결제 수단에 금액 자동 입력 //
  useEffect(() => {
    if (skipMembershipAutoFillRef.current) return;

    if (selectedEditMembership !== undefined) return;

    if (selectedMembership.id === 0) return;

    setSelectedPaymentOptions([{ id: 0, name: '현금', price: selectedMembership.price }]);
  }, [selectedMembership, selectedEditMembership])

  // 링코페이 여부 판단하기 //
  useEffect(() => {
    if (selectedEditMembership === undefined) return;

    // 링크페이로 결제한 데이터의 경우 //
    if (selectedEditMembership.merchantUid.split('-')[2] === '1' || selectedEditMembership.merchantUid.split('-')[2] === '2') {

      if (selectedEditMembership.selectedPaymentOptions !== undefined
        && selectedEditMembership.selectedPaymentOptions.length > 0) {
        setOriginalCardPrice(selectedEditMembership.cardPrice);
        setOriginalSelectedPaymentOptions(lodash.cloneDeep(selectedEditMembership.selectedPaymentOptions));
      }
      else {
        setOriginalCardPrice(selectedEditMembership.cardPrice);
        setOriginalSelectedPaymentOptions([]);
      }

      setOriginalApprovalDate(moment(selectedEditMembership.approvalDate).format('YYYY.MM.DD'));

      const isLinkPayPaidFlag = selectedEditMembership.isExpectedMemberShip === false;
      setIsLinkPayPaid(isLinkPayPaidFlag);

      if (isLinkPayPaidFlag) {
        // 결제 완료 링코페이 — 포인트 외 모든 결제수단을 '링코페이'로 강제 설정 //
        if (selectedEditMembership.selectedPaymentOptions !== undefined
          && selectedEditMembership.selectedPaymentOptions.length > 0) {
          const linkoPayOptions = selectedEditMembership.selectedPaymentOptions.map(opt =>
            opt.name === '포인트' ? opt : { ...opt, name: '링코페이' }
          );
          setSelectedPaymentOptions(linkoPayOptions);
        }
        else {
          setSelectedPaymentOptions([{ id: 0, name: '링코페이', price: selectedEditMembership.cardPrice || 0 }]);
        }
      }
      else {
        // 미결제 링코페이인 경우 기본 결제수단을 '링코페이'로 설정 //
        if (selectedEditMembership.selectedPaymentOptions !== undefined
          && selectedEditMembership.selectedPaymentOptions.length > 0) {
          const linkoPayOptions = selectedEditMembership.selectedPaymentOptions.map(opt =>
            paymentOptions.some(p => p.name === opt.name) ? opt : { ...opt, name: '링코페이' }
          );
          setSelectedPaymentOptions(linkoPayOptions);
        }
        else {
          setSelectedPaymentOptions([{ id: 0, name: '링코페이', price: selectedEditMembership.cardPrice || 0 }]);
        }
      }
    }
  }, [selectedEditMembership])

  // 최대 수강 횟수 변경시 //
  function onChangeTotalMax(value) {
    const onlyNumber = value.replace(/[^0-9]/g, ''); // 숫자 이외 제거
    setTotalMax(Number(onlyNumber));
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    if (className === 'MemberShipName') return recentlyMembership.prevSales.itemName;
    else if (className === 'Date') return moment(recentlyMembership.prevUsage.startDate).format(t('memberDetail.membershipEditModal.dateFormat')) + ' - ' + moment(recentlyMembership.prevUsage.endDate).format(t('memberDetail.membershipEditModal.dateFormat'));
    else if (className === 'TotalPrice') {
      if (recentlyMembership.prevUsage.selectedPaymentOptions === undefined || recentlyMembership.prevUsage.selectedPaymentOptions.length === 0) {
        if (recentlyMembership.prevUsage.cardPrice === 0 && recentlyMembership.prevUsage.cashPrice === 0) return t('memberDetail.payFree');
        else if (recentlyMembership.prevUsage.cardPrice === 0) return recentlyMembership.prevUsage.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.refundModal.cash');
        else if (recentlyMembership.prevUsage.cashPrice === 0) return recentlyMembership.prevUsage.cardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.refundModal.card');
        else return (parseInt(recentlyMembership.prevUsage.cashPrice) + parseInt(recentlyMembership.prevUsage.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
      }
      else {
        const allSame = recentlyMembership.prevUsage.selectedPaymentOptions.every(item => item.paymentOptionName === recentlyMembership.prevUsage.selectedPaymentOptions[0].name);
        const totalPrice = recentlyMembership.prevUsage.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

        if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + recentlyMembership.prevUsage.selectedPaymentOptions[0].paymentOptionName;
        else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
      }
    }
    else if (className === 'NotReceivedPrice') return recentlyMembership.prevUsage.notReceivedPrice.toLocaleString('ko-KR');
    else if (className === 'Validity') {
      const days = moment(recentlyMembership.prevUsage.endDate).diff(moment(), 'day');

      if (days === 0) return 'D - Day';
      else if (days > 0) return `D - ${days}`;
      else return `D + ${Math.abs(days)}`;
    }
    else if (className === 'TotalMax') {
      if (recentlyMembership.prevUsage.totalMax === -1) return recentlyMembership.prevUsage.courseTakeCount + '/∞';
      else return recentlyMembership.prevUsage.courseTakeCount + '/' + recentlyMembership.prevUsage.totalMax;
    }
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseOverPrevSales() {
    setPrevSalesColor(theme.primary);
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseLeavePrevSales() {
    setPrevSalesColor(theme.text);
  }

  function onClickPrevSales() {
    if (recentlyMembership === undefined) return;

    const willSelectCategory = categories.find(c => c.id === recentlyMembership.prevMemberShip.categoryId) || { id: 0, name: t('memberDetail.select') };
    const willSelectMembership = memberships.find(m => m.id === recentlyMembership.prevMemberShip.id) || { id: 0, name: t('memberDetail.select') };

    setSelectedCategory(willSelectCategory);

    setTimeout(() => (
      setSelectedMembership(willSelectMembership)
    ), 150);

    if (recentlyMembership.prevUsage.selectedPaymentOptions !== undefined
      && recentlyMembership.prevUsage.selectedPaymentOptions.length > 0) {
      let newSelectedPaymentOptions = lodash.cloneDeep(recentlyMembership.prevUsage.selectedPaymentOptions);

      for (let i = 0; i < newSelectedPaymentOptions.length; i++) {
        newSelectedPaymentOptions[i].id = newSelectedPaymentOptions[i].paymentOptionId;
      }

      setSelectedPaymentOptions(newSelectedPaymentOptions);
    }
    else {
      let newSelectedPaymentOptions = [];

      if (recentlyMembership.prevUsage.cashPrice != null && recentlyMembership.prevUsage.cashPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '현금', price: recentlyMembership.prevUsage.cashPrice });

      if (recentlyMembership.prevUsage.cardPrice != null && recentlyMembership.prevUsage.cardPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '카드', price: recentlyMembership.prevUsage.cardPrice });

      if (recentlyMembership.prevUsage.point != null && recentlyMembership.prevUsage.point !== 0) newSelectedPaymentOptions.push({ id: 0, name: '포인트', price: recentlyMembership.prevUsage.point });

      setSelectedPaymentOptions(newSelectedPaymentOptions);
    }

    setTotalMax(recentlyMembership.prevUsage.totalMax);
    setDiscount((recentlyMembership.prevUsage.discountPrice ?? 0).toString());
    setNotReceived((recentlyMembership.prevUsage.notReceivedPrice ?? 0).toString());
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert(t('memberDetail.membershipEditModal.alertEnterPaymentName'));
      return;
    }

    if (isLoading) {
      alert(t('memberDetail.membershipEditModal.alertSavingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert(t('memberDetail.alertDeletingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          const newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }


  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    if (newSelectedPaymentOptions[index].paymentOptionId === null) {
      newSelectedPaymentOptions[index].id = data.id;
      newSelectedPaymentOptions[index].name = data.name;
    }
    else {
      newSelectedPaymentOptions[index].paymentOptionId = data.id;
      newSelectedPaymentOptions[index].name = data.name;
    }

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') newSelectedPaymentOptions[index].price = parseInt(finalValue).toLocaleString('ko-KR');
    else newSelectedPaymentOptions[index].price = finalValue;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 할인 금액 변경시 //
  function onChangeDiscount(value) {
    const finalValue = value.replaceAll(',', '');

    if (finalValue !== '') setDiscount(parseInt(finalValue).toLocaleString('ko-KR'));
    else setDiscount(finalValue);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    const unpaid = parseInt(notReceived.toString().replaceAll(',', '')) || 0;
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: unpaid });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    const newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 등록을 위해 모든 데이터가 채워졌는지 여부 확인 //
  function checkAvailableRegistration() {
    if (startDate === '') {
      alert(t('memberDetail.membershipEditModal.alertSetMembershipStartDate'));
      return false;
    }

    if (endDate === '') {
      alert(t('memberDetail.membershipEditModal.alertSetMembershipEndDate'));
      return false;
    }

    if (approvalDate === '') {
      alert(t('memberDetail.membershipEditModal.alertSetPaymentDate'));
      return false;
    }

    if (selectedMembership.id === 0) {
      alert(t('memberDetail.membershipEditModal.alertSelectMembershipPlease'));
      return false;
    }

    const checkStartDate = moment(startDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'));
    const checkEndDate = moment(endDate.replaceAll('.', '-') + 'T23:59:59');

    if (checkEndDate.isBefore(checkStartDate)) {
      alert(t('memberDetail.membershipEditModal.alertInvalidEndDate'));
      return false;
    }

    return true;
  }

  // 회원 등록 모달에서 현장결제 클릭시 //
  function onClickOnSitePayment() {
    if (!checkAvailableRegistration()) {
      setIsViewPaymentModal(false);
      return;
    }

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }

    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }

      finalSelectedPaymentOptions[i].price = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    if (parseInt(finalPoint) > 0 && parseInt((finalPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('memberDetail.alertPointExceeded'));
      return;
    }
    else if (isInProgress) {
      alert(t('memberDetail.membershipEditModal.alertSavingInProgress'));
      return;
    }

    setIsInProgress(true);

    let requestData = {
      registrationType: 'ADD_MEMBERSHIP',
      storeId: parseInt(window.sessionStorage.getItem('StoreId')),
      memberId: memberId,
      membershipId: selectedMembership.id,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discountPrice: parseInt(discount.toString().replaceAll(',', '')),
      notReceivedPrice: parseInt(notReceived.toString().replaceAll(',', '')),
      point: finalPoint,
      approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
      startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
      endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
      totalMax: totalMax,
      membershipPaymentOptions: finalSelectedPaymentOptions
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', requestData);

        if (responseData.status === 200) {
          setIsInProgress(false);
          onClickExit();
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.refundModal.alertInvalidRequest'));
          setIsInProgress(false);
          return;
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.membershipEditModal.alertAlreadyPaid'));
          setIsInProgress(false);
          return;
        }
        else if (responseData.status === 204) {
          alert(t('memberDetail.membershipEditModal.alertPaymentNotFound'));
          setIsInProgress(false);
          return;
        }
        else {
          setIsInProgress(false);
        }
      }
    )();
  }

  // 회원 등록 모달에서 링코페이 클릭시 //
  function onClickLinkoPay() {
    if (!checkAvailableRegistration()) {
      setIsViewPaymentModal(false);
      return;
    }

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }


    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }

      finalSelectedPaymentOptions[i].price = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    if (parseInt(finalPoint) > 0 && parseInt((finalPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('memberDetail.alertPointExceeded'));
      return;
    }
    else if (isInProgress) {
      alert(t('memberDetail.membershipEditModal.alertSavingInProgress'));
      return;
    }

    setIsInProgress(true);

    const storeId = window.sessionStorage.getItem('StoreId');

    const data = {
      registrationType: 'ADD_MEMBERSHIP',
      storeId: parseInt(storeId),
      memberId: memberId,
      membershipId: selectedMembership.id,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discountPrice: parseInt(discount.toString().replaceAll(',', '')),
      notReceivedPrice: parseInt(notReceived.toString().replaceAll(',', '')),
      point: finalPoint,
      startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
      endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
      approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
      totalMax: totalMax,
      membershipPaymentOptions: finalSelectedPaymentOptions
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', data);

        if (responseData.status === 200) {
          setIsInProgress(false);
          onClickExit();
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.membershipEditModal.alertNotLinkCoachMember'));
          setIsInProgress(false);
          return;
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.alertDataNotExist'));
          setIsInProgress(false);
          return;
        }
        else {
          alert(responseData.error);
          setIsInProgress(false);
          return;
        }
      }
    )();
  }

  // 저장하기 버튼 클릭시 //
  function onClickSave() {
    if (selectedMembership.id !== 0) {
      let totalPayment = 0;

      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== '' && selectedPaymentOptions[i].price != null) {
          totalPayment += parseInt(selectedPaymentOptions[i].price.toString().replaceAll(',', '') || 0);
        }
      }

      if (discount !== '') totalPayment += parseInt(discount.replaceAll(',', ''));

      if (isLinkoPayActive && totalPayment > selectedMembership.price) {
        alert(t('memberDetail.membershipEditModal.alertOverpaid'));
        return;
      }
    }

    const unpaidAmount = parseInt(notReceived.toString().replaceAll(',', ''));

    if (unpaidAmount > 0) {
      const confirmed = window.confirm(t('memberDetail.membershipEditModal.alertUnpaidRemaining', { amount: unpaidAmount.toLocaleString('ko-KR') }));

      if (!confirmed) return;
    }

    if (isEdit) {

      if (!checkAvailableRegistration()) {
        setIsViewPaymentModal(false);
        return;
      }

      let finalCashPrice = 0;
      let finalCardPrice = 0;
      let finalPoint = 0;

      let finalSelectedPaymentOptions = [];

      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== ''
          && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].paymentOptionId === undefined) {
          finalSelectedPaymentOptions[i].paymentOptionId = finalSelectedPaymentOptions[i].id;
          finalSelectedPaymentOptions[i].id = 0;
        }
        finalSelectedPaymentOptions[i].paymentOptionName = finalSelectedPaymentOptions[i].name;
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].paymentOptionId === 0) {
          if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        }

        finalSelectedPaymentOptions[i].price = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }

      if (parseInt(finalPoint) > 0 && parseInt((finalPoint).toString().replaceAll(',', '')) > parseInt((totalPoint + usedPoint).toString().replaceAll(',', ''))) {
        alert(t('memberDetail.alertPointExceeded'));
        return;
      }

      // 엔드포인트 분기 결정 //
      const merchantUidPart = selectedEditMembership.merchantUid?.split('-')[2];
      const isLinkoPayMerchant = merchantUidPart === '1' || merchantUidPart === '2';
      const isUnpaidLinkoPayCase = isLinkoPayMerchant && selectedEditMembership.isExpectedMemberShip !== false;
      const isCompletedLinkoPayCase = isLinkoPayMerchant && selectedEditMembership.isExpectedMemberShip === false;

      // 링코페이 결제 완료 케이스 — state 값과 무관하게 결제 수단 이름/금액 강제 보정
      if (isCompletedLinkoPayCase) {
        finalCashPrice = 0;
        finalCardPrice = 0;
        for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
          if (finalSelectedPaymentOptions[i].name !== '포인트') {
            finalSelectedPaymentOptions[i].name = '링코페이';
            finalSelectedPaymentOptions[i].paymentOptionName = '링코페이';
            finalCardPrice += finalSelectedPaymentOptions[i].price;
          }
        }
      }

      // 결제 타입이 변경되는 케이스 (change-payment):
      // - 현장결제 → 링코페이 (USAGE → LINKO_PAY)
      // - 링코페이 대기 → 현장결제 (EXPECTED → ON_SITE)
      // 링코페이 결제 완료 케이스는 항상 modify (UI에서 결제 수단 변경 불가)
      const isTypeChanging = isCompletedLinkoPayCase
        ? false
        : (!isLinkPayPaid && !isUnpaidLinkoPayCase && isLinkoPayActive) ||
          isUnpaidLinkoPayCase ||
          (isLinkPayPaid && !isLinkoPayActive);

      // 링코페이 확정 내용 수정 시 결제일 변경 불가 //
      if (!isTypeChanging && isCompletedLinkoPayCase) {
        if (originalApprovalDate !== approvalDate) {
          alert(t('memberDetail.membershipEditModal.alertLinkpayDateCannotChange'));
          setApprovalDate(originalApprovalDate);
          return;
        }
      }

      if (isInProgress) {
        alert(t('memberDetail.membershipEditModal.alertSavingInProgress'));
        return;
      }

      setIsInProgress(true);

      const fetchModule = new FetchModule();

      (
        async () => {
          let endpoint;
          let requestData;

          if (isTypeChanging) {
            const sourceType = isUnpaidLinkoPayCase ? 'EXPECTED' : 'USAGE';
            const targetType = isLinkoPayActive ? 'LINKO_PAY' : 'ON_SITE';

            endpoint = 'membership/usage/change-payment';
            requestData = {
              sourceType: sourceType,
              sourceId: isUnpaidLinkoPayCase ? selectedEditMembership.expectedUsageId : selectedEditMembership.usageId,
              storeId: parseInt(window.sessionStorage.getItem('StoreId')),
              memberId: parseInt(memberId),
              memberShipId: selectedMembership.id,
              merchantUid: selectedEditMembership.merchantUid,
              targetType: targetType,
              startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
              endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
              approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
              cardPrice: finalCardPrice,
              cashPrice: finalCashPrice,
              discountPrice: parseInt(discount.toString().replaceAll(',', '')),
              notReceivedPrice: parseInt(notReceived.toString().replaceAll(',', '')),
              point: finalPoint,
              totalMax: totalMax,
              selectedPaymentOptions: finalSelectedPaymentOptions.map(opt => ({
                id: 0,
                paymentOptionId: opt.paymentOptionId,
                paymentOptionName: opt.paymentOptionName,
                price: opt.price
              }))
            };
          }
          else {
            endpoint = 'membership/usage/modify';
            requestData = {
              id: selectedEditMembership.usageId,
              storeId: parseInt(window.sessionStorage.getItem('StoreId')),
              memberId: parseInt(memberId),
              memberShipId: selectedMembership.id,
              merchantUid: selectedEditMembership.merchantUid,
              startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
              endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
              approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
              cardPrice: finalCardPrice,
              cashPrice: finalCashPrice,
              discountPrice: parseInt(discount.toString().replaceAll(',', '')),
              notReceivedPrice: parseInt(notReceived.toString().replaceAll(',', '')),
              point: finalPoint,
              totalMax: totalMax,
              selectedPaymentOptions: finalSelectedPaymentOptions.map(opt => ({
                id: opt.id,
                paymentOptionId: opt.paymentOptionId,
                paymentOptionName: opt.paymentOptionName,
                price: opt.price
              }))
            };
          }


          const responseData = await fetchModule.postDataVersion2(endpoint, 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('memberDetail.membershipEditModal.alertSaveComplete'));
            onClickExit();
            setIsInProgress(false);
          }
          else if (responseData.status === 401) {
            alert(t('memberDetail.alertLoginRetry'));
            history.push('/');
            setIsInProgress(false);
          }
          else {
            alert(t('memberDetail.extensionModal.alertSaveFailed'));
            setIsInProgress(false);
          }
        }
      )();
    }
    else {
      if (!checkAvailableRegistration()) return;

      let finalCashPrice = 0;
      let finalCardPrice = 0;
      let finalPoint = 0;
      const finalSelectedPaymentOptions = [];


      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== ''
          && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].id === 0) {
          if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        }

        finalSelectedPaymentOptions[i].price = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }

      if (parseInt(finalPoint) > 0 && parseInt(finalPoint.toString()) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
        alert(t('memberDetail.alertPointExceeded'));
        return;
      }
      else if (isInProgress) {
        alert(t('memberDetail.membershipEditModal.alertSavingInProgress'));
        return;
      }

      setIsInProgress(true);

      const requestData = {
        registrationType: 'ADD_MEMBERSHIP',
        storeId: parseInt(window.sessionStorage.getItem('StoreId')),
        memberId: parseInt(memberId),
        membershipId: selectedMembership.id,
        cardPrice: finalCardPrice,
        cashPrice: finalCashPrice,
        discountPrice: parseInt(discount.toString().replaceAll(',', '')),
        notReceivedPrice: parseInt(notReceived.toString().replaceAll(',', '')),
        point: finalPoint,
        approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
        startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
        totalMax: totalMax,
        membershipPaymentOptions: finalSelectedPaymentOptions.map(opt => ({
          id: opt.id,
          name: opt.name,
          price: opt.price
        }))
      }


      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', requestData);

          if (responseData.status === 200) {
            setIsInProgress(false);
            onClickExit();
          }
          else if (responseData.status === 401) {
            alert(t('memberDetail.alertLoginRetry'));
            history.push('/');
            setIsInProgress(false);
          }
          else {
            alert(t('memberDetail.extensionModal.alertSaveFailed'));
            setIsInProgress(false);
          }
        }
      )();
    }
  }

  return (
    <TotalModalWrapper>
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      {
        isViewPaymentModal && isUseLinkoPay &&
        <LinkoPayPaymentModal
          onClickOnSitePayment={onClickOnSitePayment}
          onClickLinkoPay={onClickLinkoPay}
          onClickExit={() => setIsViewPaymentModal(false)} />
      }
      {
        isViewPaymentModal && !isUseLinkoPay &&
        <OnSitePaymentModal
          selectedMembership={selectedMembership}
          selectedPaymentOptions={selectedPaymentOptions}
          selectedLockerPaymentOptions={[]}
          onClickOnSitePayment={onClickOnSitePayment}
          onClickExit={() => setIsViewPaymentModal(false)} />
      }
      <ModalView>
        <MembershipBoxInnerWrapper>
          <MembershipBoxTitleWrapper>
            {
              isEdit ?
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{memberName ? t('memberDetail.membershipEditModal.membershipEditTitleWithName').replace('{memberName}', memberName) : t('memberDetail.membershipEditModal.membershipEditTitle')}</Text>
                :
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{memberName ? t('memberDetail.addMembershipWithName').replace('{memberName}', memberName) : t('memberDetail.addMembership')}</Text>
            }
          </MembershipBoxTitleWrapper>
          {recentlyMembership !== undefined && recentlyMembership.prevSales !== undefined && recentlyMembership.prevMemberShip !== undefined &&
            <PastMembershipInfo onClick={onClickPrevSales} onMouseOver={onMouseOverPrevSales} onMouseLeave={onMouseLeavePrevSales}>
              <TitleWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.prevMembershipInfo')}</Text>
              </TitleWrapper>
              <DivisionLine margin={10} />
              <InfoBox>
                <RowWrapper gap={10}>
                  <PrevSalesInfoBoxWrapper width={120} marginRight={10}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.membershipEditModal.membership')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('MemberShipName')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                  <PrevSalesInfoBoxWrapper width={125} marginRight={10}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.membershipEditModal.period')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                </RowWrapper>

                <RowWrapper gap={10}>
                  <PrevSalesInfoBoxWrapper marginRight={10}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.paymentAmount')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalPrice')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                  <PrevSalesInfoBoxWrapper marginRight={10}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.colUnpaid')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('NotReceivedPrice')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                  <PrevSalesInfoBoxWrapper marginRight={10}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.colRemaining')}</Text>
                    <PrevSalesTextWrapper>
                      <DdayWrapper>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor === theme.text ? theme.white : prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Validity')}</Text>
                      </DdayWrapper>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                  <PrevSalesInfoBoxWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.colSessions')}</Text>
                    <PrevSalesTextWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalMax')}</Text>
                    </PrevSalesTextWrapper>
                  </PrevSalesInfoBoxWrapper>
                </RowWrapper>
              </InfoBox>
            </PastMembershipInfo>}
          <InputInfoWrapper>
            <MembershipTitleWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.addEnrollMembership')}</Text>
            </MembershipTitleWrapper>
            <DivisionLine style={{ padding: '0 10px' }} />
            <LayerWrapper
              padding={10}
              gap={20}
              style={{ zIndex: selectedPaymentOptions.length + 3 }}>
              <InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.category')}</Text>
                <OptionSelectBox
                  value={selectedCategory}
                  setValue={setSelectedCategory}
                  options={categories}
                  disabled={isLinkPayPaid || categories.length === 0} />
              </InputWrapper>
              <InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipEditModal.membership')}</Text>
                <OptionSelectBox
                  key={selectedCategory.id}
                  value={selectedMembership}
                  setValue={onChangeSelectedMembership}
                  options={categorizedMemberships}
                  disabled={isLinkPayPaid || categorizedMemberships.length === 0} />
              </InputWrapper>
            </LayerWrapper>
            <LayerWrapper
              padding={10}
              gap={20}
              style={{ zIndex: selectedPaymentOptions.length + 2 }}>
              <CalendarWrapper style={{ flex: 1, minWidth: 0 }}>
                <InputWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.membershipStartDate')}</Text>
                  <CalenderInput
                    value={startDate}
                    setValue={onChangeStartDate}
                    disabled={false}
                    placeholder={t('memberDetail.membershipAddModal.membershipStartDate')} />
                </InputWrapper>
                <InputWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.membershipEndDate')}</Text>
                  <CalenderInput
                    value={endDate}
                    setValue={setEndDate}
                    disabled={false}
                    placeholder={t('memberDetail.membershipAddModal.membershipEndDate')} />
                </InputWrapper>
              </CalendarWrapper>
              <InputWrapper style={{ flex: 1, minWidth: 0 }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.maxSessionCount')}</Text>
                <UnitInputWrapper>
                  <CustomInput
                    value={totalMax === -1 ? t('memberDetail.membershipAddModal.noLimit') : totalMax}
                    setValue={onChangeTotalMax}
                    placeholder='0'
                    disabled={totalMax === -1}
                    flexShrink={true} />
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.membershipEditModal.timesUnit')}</Text>
                </UnitInputWrapper>
              </InputWrapper>
            </LayerWrapper>
          </InputInfoWrapper>
        </MembershipBoxInnerWrapper>
        <PaymentInfoWrapper>
          <PaymentLayerWrapper
            padding={10}
            gap={20}
            style={{ zIndex: selectedPaymentOptions.length + 1 }}>
            <InputWrapper style={{ flex: 1, minWidth: 0 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.paymentDate')}</Text>
              <CalenderInput
                value={approvalDate}
                setValue={setApprovalDate}
                disabled={isLinkPayPaid}
                placeholder={t('memberDetail.refundModal.paymentDate')} />
            </InputWrapper>
            <RowDivisionLine />
            <InputWrapper style={{ flex: 1, minWidth: 0 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.membershipPrice')}</Text>
              <UnitInputWrapper>
                {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                <CustomInput
                  value={selectedMembership.id === 0 ? '0' : selectedMembership.price.toLocaleString('ko-KR')}
                  placeholder='0'
                  disabled2={true}
                  textAlign={isEng ? 'left' : 'right'}
                  flexShrink={true} />
                {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
              </UnitInputWrapper>
            </InputWrapper>
          </PaymentLayerWrapper>
          {
            selectedPaymentOptions.map((data, index) => (
              <PaymentLayerWrapper
                key={`SelectedPaymentOptions-${selectedMembership.id}-${index}`}
                padding={10}
                gap={20}
                style={{ zIndex: selectedPaymentOptions.length - index }}>
                <InputWrapper style={{ flex: 1, minWidth: 0 }}>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipEditModal.paymentMethod') + ' ' + (index === 0 ? '' : index + 1)}</Text>
                    {
                      (!isLinkPayPaid || data.name === '포인트') && index !== 0 &&
                      <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                        <StyledTrashIcon />
                      </DeleteButton>
                    }
                  </PaymentOptionTitleWrapper>
                  {
                    isLinkPayPaid && data.name !== '포인트' ?
                      <LinkoPayTextView>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipEditModal.linkoPay')}</Text>
                      </LinkoPayTextView>
                      :
                      <PaymentOptionSettingSelectBox
                        index={index}
                        value={data}
                        setValue={onChangeSelectedPaymentOptions}
                        options={paymentOptions}
                        disabled={paymentOptions.length === 0}
                        includeLinkoPayOption={true}
                        onClickAdditionOption={onClickAdditionOption}
                        onClickDeleteOption={onClickDeleteOption} />
                  }
                </InputWrapper>
                <RowDivisionLine />
                <InputWrapper style={{ flex: 1, minWidth: 0 }}>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipEditModal.receivedPrice')}</Text>
                    {data.paymentOptionId === 0 && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subKey} cursor='default'>{totalPoint.toLocaleString('ko-KR') + t('memberDetail.membershipEditModal.pointAvailable')}</Text>}
                  </PaymentOptionTitleWrapper>
                  <UnitInputWrapper>
                    {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                    <PaymentOptionCustomInput
                      index={index}
                      value={(data.price ?? 0).toLocaleString('ko-KR')}
                      setValue={onChangePaymentOptionPrice}
                      placeholder='0'
                      disabled={isLinkPayPaid && data.name !== '포인트'}
                      textAlign={isEng ? 'left' : 'right'} />
                    {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                  </UnitInputWrapper>
                </InputWrapper>
              </PaymentLayerWrapper>
            ))
          }
        </PaymentInfoWrapper>
        {
          !isLinkPayPaid &&
          <AddPaymentOptionButtonWrapper>
          <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>{t('memberDetail.membershipEditModal.addPaymentOption')}</AddPaymentOptionButton>
          </AddPaymentOptionButtonWrapper>
        }
        {!isLinkPayPaid &&
          <DiscountLayerWrapper padding={10} gap={20}>
            <InputWrapper style={{ flex: 1, minWidth: 0 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.discountAmount')}</Text>
              <UnitInputWrapper>
                {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subKey} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                <DiscountAmountInput
                  value={discount.toLocaleString('ko-KR')}
                  setValue={onChangeDiscount}
                  placeholder='0' />
                {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subKey} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
              </UnitInputWrapper>
            </InputWrapper>
            <RowDivisionLine />
            <InputWrapper style={{ flex: 1, minWidth: 0 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipAddModal.unpaidAmount')}</Text>
              <UnitInputWrapper>
                {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.pointRed} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                <NotReceivedInputView style={{ justifyContent: isEng ? 'flex-start' : 'flex-end' }}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.pointRed} cursor='default'>{notReceived.toLocaleString('ko-KR')}</Text>
                </NotReceivedInputView>
                {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.pointRed} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
              </UnitInputWrapper>
            </InputWrapper>
          </DiscountLayerWrapper>
        }
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.modalCancel')}</Text>
          </ExitButton>
          {isLinkoPayActive && !isLinkPayPaid
            ? <LinkoPayButton onClick={onClickSave}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>
                {isEdit
                  ? t('memberDetail.membershipEditModal.btnResendLinkoPay')
                  : t('memberDetail.membershipEditModal.btnSendLinkoPay')}
              </Text>
            </LinkoPayButton>
            : <SaveButton $isLinkoPay={isEdit && isLinkPayPaid} onClick={onClickSave}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>
                {t('memberDetail.membershipEditModal.btnSave')}
              </Text>
            </SaveButton>
          }
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}




const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 60px 0px;
  padding: 20px 10px;

  width: 556px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;


  gap: 10px;

  width: 100%
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: ${props => props.gap}px;

  width: 100%;
  height: 47px;

  &:hover {
    cursor: pointer;
  }
`;

const PrevSalesInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: ${props => props.marginRight}px;

  flex: 1;
  min-width: 0;
  height: 48px;

  overflow: hidden;
  gap: 8px;
`;

const PrevSalesTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden; 
`;

const DdayWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: ${props => props.theme.line};

  & > p {
    line-height: 1;
  }
`;

const MembershipBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const MembershipBoxTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 10px;

  width: 100%;
`;

const PastMembershipInfo = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 10px;
  margin: 10px 0 20px 0;

  width: calc(100% - 20px);

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};
`;

const InputInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;

  width: 100%;
`;

const MembershipTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 10px 0 0 10px;

  width: 100%;
`;

const LayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  padding: 0 ${props => props.padding}px ${props => props.padding}px ${props => props.padding}px;

  width: 100%;
  box-sizing: border-box;

  gap: ${props => props.gap}px;
`;

const PaymentLayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  padding: 0 ${props => props.padding}px 0 ${props => props.padding}px;

  width: 100%;
  box-sizing: border-box;

  gap: ${props => props.gap}px;
`;

const DiscountLayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  padding: ${props => props.padding}px;

  width: 100%;
  box-sizing: border-box;

  gap: ${props => props.gap}px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;

  width: 100%;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;

  width: 100%;
`;

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const NotReceivedInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

	padding: 0 8px;

  width: 100%;
  height: 30px;

	border: 1px solid ${props => props.theme.subBackground};
	border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;

  width: 100%;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.margin}px;
  margin-bottom: ${props => props.margin}px;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color: ${props => props.theme.line};
`;

const AddPaymentOptionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 10px;

  width: 100%;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin: 20px 10px 10px 10px;

  width: 100%;
  height: 40px;
  
  border-radius: 20px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.line};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.subBackground};
      background-color: ${props => props.theme.subKey};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const LinkoPayTextView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border-radius: 5px;
  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRedAlpha50};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRed};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledTrashIcon = styled(TrashIcon)`
  width: 14px;
  height: 14px;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 20px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 16px;

  min-width: 80px;
  box-sizing: border-box;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.$isLinkoPay ? props.theme.subKey : props.theme.primary};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LinkoPayButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;
